export default function compareEventDates(eventA, eventB) {
  if (eventA.year < eventB.year) {
    return -1;
  } else if (eventA.year > eventB.year) {
    return 1;
  } else if (eventA.month < eventB.month) {
    return -1;
  } else if (eventA.month > eventB.month) {
    return 1;
  } else if (eventA.day < eventB.day) {
    return -1;
  } else if (eventA.day > eventB.day) {
    return 1;
  }
  return 0;
}
